import { jsx as _jsx } from "react/jsx-runtime";
import Spinner from "Icons/Spinner";
export default function PageSpinner() {
    return (_jsx("div", { className: "flex f-center", children: _jsx(Spinner, { width: 50, height: 50 }) }));
}
